import { createRequestTypes } from '../../../utils/actionHelpers';

export default createRequestTypes('DASHBOARD', [
  'READ_DASHBOARD',
]);
